import React, { useEffect, useState } from 'react';
import AccountMainLayout from '../Layout/AccountMainLayout';
import { Link, useNavigate } from 'react-router-dom';
// import Accordion from '../components/Accordion';
import { getApi, postApi } from '../utils/api';
import {
  API_BASE_URL,
  cancelSubscriptionApi,
  membershipCard,
  overview,
} from '../utils/endpoint';
import Cookies from 'js-cookie';
import { generatePrice, getGreeting } from '../utils/helpers';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { ThreeDots } from 'react-loader-spinner';
import { logoutUser } from '../utils/Storage';
import ErrorBanner from './ErrorBanner';

const Overview = () => {
  const { personalDetail } = useSelector((state) => state.signup);
  const navigate = useNavigate();
  const [plan, setPlan] = useState({});
  const [upcomingInvoice, setUpcomingInvoice] = useState({});
  const [subscription, setSubscription] = useState({});
  const [userData, setUserData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [hasOverviewError, setHasOverviewError] = useState(false);
  const access_token = Cookies.get('userToken');
  const [showError, setShowError] = useState(false);
  const [showErrorDetail, setShowErrorDetail] = useState({
    isError: true,
    message: '',
  });
  const actionsDisabled = isLoading || hasOverviewError;

  useEffect(() => {
    if (
      personalDetail?.subscriptions?.length === 0 &&
      Cookies.get('isSubscribed') === undefined
    ) {
      navigate('/plans');
    }
  }, []);

  useEffect(() => {
    fetchOverView();
  }, []);

  const fetchOverView = async () => {
    let data = localStorage.getItem('userData');
    setIsLoading(true);
    setHasOverviewError(false);
    setUserData(JSON.parse(data));
    await getApi(overview, access_token)
      .then((res) => {
        if (res?.data?.success) {
          let subscriptionType =
            res?.data?.data?.plans?.subscriptionInterval === 'month'
              ? 'Monthly'
              : 'Yearly';

          let obj = res?.data.data.plans;
          obj.subscriptionType = subscriptionType;

          setPlan(obj);
          setSubscription(res?.data.data.subscription);
          setUpcomingInvoice(res?.data.data.upcomingInvoice);
          setHasOverviewError(false);
          return;
        }

        setHasOverviewError(true);
        setShowErrorDetail({
          isError: true,
          message: res?.data?.message || 'Unable to load account overview.',
        });
        setShowError(true);
      })
      .catch((err) => {
        if (
          err?.response?.status === 401 &&
          err?.response?.statusText === 'Unauthorized'
        ) {
          logoutUser();
          navigate('/');
          return;
        }

        setHasOverviewError(true);
        setShowErrorDetail({
          isError: true,
          message:
            err?.response?.data?.message || 'Unable to load account overview.',
        });
        setShowError(true);
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleCancelMembership = (e) => {
    e.preventDefault();
    if (actionsDisabled) {
      return;
    }

    let obj = {
      subscription_id: subscription?.id,
    };
    postApi(cancelSubscriptionApi, obj, access_token)
      .then((res) => {
        if (res?.data?.success) {
          const modalClose =
            document.getElementsByClassName('cancel-address')[0];
          modalClose.click();
          setShowErrorDetail({
            isError: false,
            message: res?.data?.message,
          });
          setShowError(true);
          fetchOverView();
          setTimeout(() => {
            handleClose();
          }, 4000);
        }
      })
      .catch((err) => {
        setShowErrorDetail({
          isError: true,
          message: err?.response?.data?.message,
        });
        setShowError(true);
        setTimeout(() => {
          handleClose();
        }, 4000);
      });
  };

  const handleClose = () => {
    setShowError(false);
    setShowErrorDetail({
      isError: true,
      message: '',
    });
  };

  const owner = subscription?.owner || {};
  const planDetails = plan?.plan || {};
  const packagePrices = Array.isArray(plan?.package_prices)
    ? plan.package_prices
    : [];

  const membershipName =
    planDetails?.name || plan?.name || 'Caliber Card - Gold Tier';
  const memberName =
    owner?.name ||
    userData?.fullName ||
    personalDetail?.fullName ||
    personalDetail?.name ||
    'Loading...';

  const computedAddress = [
    owner?.address,
    owner?.city,
    owner?.state,
    owner?.zipcode,
    owner?.country,
  ]
    .filter(Boolean)
    .join(', ');

  const memberAddress =
    computedAddress || userData?.address || '221B Baker Street, London, UK';

  const membershipStatus = (
    subscription?.stripe_status ||
    subscription?.status ||
    'active'
  ).toLowerCase();

  const memberSince = subscription?.created_at
    ? moment(subscription.created_at).format('MMMM DD, YYYY')
    : subscription?.created
      ? moment.unix(subscription.created).format('MMMM DD, YYYY')
      : 'May 05, 2024';

  const validUpto = subscription?.ends_at
    ? moment(subscription.ends_at).format('MMMM DD, YYYY')
    : subscription?.current_period_end
      ? moment.unix(subscription.current_period_end).format('MMMM DD, YYYY')
      : upcomingInvoice?.lines?.data?.[0]?.period?.end
        ? moment
            .unix(upcomingInvoice.lines.data[0].period.end)
            .format('MMMM DD, YYYY')
        : 'May 05, 2027';

  const parsedBenefits = (plan?.description || '')
    .split(/\r?\n|;+/)
    .map((item) => item.trim())
    .filter(Boolean);

  const fallbackBenefits = [
    'Priority reservations at all partner venues',
    'Complimentary valet and concierge services',
    'Exclusive member-only events and tastings',
    'Up to 20% off on dining and stays',
  ];

  const benefitsToRender = parsedBenefits.length
    ? parsedBenefits
    : fallbackBenefits;

  const purchasedPackagePrice = packagePrices.find(
    (price) => price?.stripe_price_id === subscription?.stripe_price
  );

  const purchasedInvoiceLine = upcomingInvoice?.lines?.data?.find(
    (line) => line?.price?.id === subscription?.stripe_price
  );

  const fallbackRecurringPrice = packagePrices.find(
    (price) => !price?.is_prepaid && price?.price
  );

  const packagePriceLabel = purchasedPackagePrice?.price
    ? `$${Number(purchasedPackagePrice.price).toFixed(2)} ${
        purchasedPackagePrice?.description ||
        (plan?.subscriptionType
          ? `/ ${plan.subscriptionType.toLowerCase()}`
          : '/ month')
      }`
    : purchasedInvoiceLine?.amount
      ? `${generatePrice(purchasedInvoiceLine.amount / 100)} ${
          purchasedInvoiceLine?.price?.recurring?.interval
            ? `/ ${purchasedInvoiceLine.price.recurring.interval}`
            : plan?.subscriptionType
              ? `/ ${plan.subscriptionType.toLowerCase()}`
              : ''
        }`
      : fallbackRecurringPrice?.price
        ? `$${Number(fallbackRecurringPrice.price).toFixed(2)} ${
            fallbackRecurringPrice?.description ||
            (plan?.subscriptionType
              ? `/ ${plan.subscriptionType.toLowerCase()}`
              : '/ month')
          }`
        : null;

  return (
    <>
      <AccountMainLayout>
        {showError && (
          <ErrorBanner error={showErrorDetail} handleClose={handleClose} />
        )}
        <div className="account-login account-new pt-5">
          {isLoading && (
            <div className="loader">
              <ThreeDots
                height="110"
                width="110"
                radius="10"
                color="#aeaeae"
                ariaLabel="three-dots-loading"
                wrapperStyle={{ display: 'contents' }}
                wrapperClassName=""
                visible={true}
              />
            </div>
          )}
          {!isLoading && (
            <>
              <div className="d-none">
                <div className="card-user-id-number">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="over-view-heading">
                        <h1 className="sub-title theme-color">
                          {getGreeting()},{' '}
                          {Object.keys(personalDetail).length > 0
                            ? (personalDetail?.name ||
                                personalDetail?.fullName) + '!'
                            : // + (personalDetail?.last_name || personalDetail?.lastName) +
                              // '!'
                              userData
                              ? userData?.fullName +
                                // ' ' +  userData?.lastName +
                                '!'
                              : 'Loading....'}
                        </h1>
                      </div>
                      {upcomingInvoice?.total !== 0 && (
                        <>
                          <h3 className="section-heading card-heading pt-4 pb-3">
                            Account Overview
                          </h3>
                          <div className="col-lg-4 mb-3">
                            <div className="card card-list">
                              <div className="card-header section-heading card-heading">
                                Upcoming Bill
                              </div>
                              <ul className="list-group list-group-flush overview-card">
                                <li className="dollar">
                                  {upcomingInvoice?.total
                                    ? generatePrice(
                                        upcomingInvoice?.total / 100
                                      )
                                    : 'Loading......'}
                                </li>
                                <li className="next">Next Payment Date</li>
                                <li className="pay">
                                  Auto Pay on{' '}
                                  {upcomingInvoice?.next_payment_attempt
                                    ? moment
                                        .unix(
                                          upcomingInvoice?.next_payment_attempt
                                        )
                                        .format('MMMM DD, YYYY')
                                    : 'Loading......'}
                                </li>
                                <Link
                                  to="/account-billing"
                                  className={`button-golden border-golden ${actionsDisabled ? 'disable' : ''}`}
                                  onClick={(e) => {
                                    if (actionsDisabled) {
                                      e.preventDefault();
                                    }
                                  }}
                                  aria-disabled={actionsDisabled}
                                  tabIndex={actionsDisabled ? -1 : 0}
                                >
                                  BILLING DETAILS
                                </Link>
                              </ul>
                            </div>
                          </div>
                        </>
                      )}
                      <div
                        className={`${
                          upcomingInvoice?.total !== 0 ? 'col-lg-4' : 'col-lg-6'
                        }  mb-3`}
                      >
                        <div className="card card-list">
                          <div className="card-header section-heading card-heading">
                            Your Package
                          </div>
                          <ul className="list-group list-group-flush overview-card">
                            <li className="dollar dollar-list">
                              <div className="web-image">
                                <img
                                  src="../images/brand_emblem.svg"
                                  alt="weblogo"
                                  className="img-fluid"
                                />
                              </div>
                              <div className="web-text">
                                <p>Membership</p>
                                <h5>
                                  {plan?.plan?.name
                                    ? plan?.plan?.name
                                    : 'Loading...'}
                                </h5>
                              </div>
                            </li>
                            <li className="next text-capitalize text-danger">
                              {subscription?.cancellation_status &&
                                ' Cancellation Status ( ' +
                                  subscription?.cancellation_status +
                                  ' )'}
                            </li>
                            <Link
                              data-bs-toggle={
                                actionsDisabled ? undefined : 'modal'
                              }
                              data-bs-target={
                                actionsDisabled
                                  ? undefined
                                  : '#exampleModal_membership'
                              }
                              className={`button-golden  clear-button  ${subscription?.cancellation_status === 'pending' ? 'disable' : ''} `}
                              onClick={(e) => {
                                if (actionsDisabled) {
                                  e.preventDefault();
                                }
                              }}
                              aria-disabled={actionsDisabled}
                              tabIndex={actionsDisabled ? -1 : 0}
                            >
                              Cancel Membership
                            </Link>
                          </ul>
                        </div>
                      </div>
                      <div
                        className={`${
                          upcomingInvoice?.total !== 0 ? 'col-lg-4' : 'col-lg-6'
                        }  mb-3`}
                      >
                        <div className="card card-list">
                          <div className="card-header section-heading card-heading">
                            Quick Links
                          </div>
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item link">
                              <Link
                                to="/contact-us"
                                onClick={(e) => {
                                  if (actionsDisabled) {
                                    e.preventDefault();
                                  }
                                }}
                                aria-disabled={actionsDisabled}
                                tabIndex={actionsDisabled ? -1 : 0}
                              >
                                Contact Support
                              </Link>
                              <i
                                className="fa fa-chevron-right"
                                aria-hidden="true"
                              ></i>
                            </li>
                            <li className="list-group-item link d-none">
                              <Link
                                to={
                                  API_BASE_URL +
                                  membershipCard +
                                  personalDetail?.id
                                }
                                target="_blank"
                                rel="noreferrer"
                                onClick={(e) => {
                                  if (actionsDisabled) {
                                    e.preventDefault();
                                  }
                                }}
                                aria-disabled={actionsDisabled}
                                tabIndex={actionsDisabled ? -1 : 0}
                              >
                                Download ID Card
                              </Link>
                              <i
                                className="fa fa-chevron-right"
                                aria-hidden="true"
                              ></i>
                            </li>
                            {/* <li className="list-group-item link">
                            <a href="#">Download ID Card</a>
                            <i
                              className="fa fa-chevron-right"
                              aria-hidden="true"
                            ></i>
                          </li> */}
                            <li className="list-group-item link">
                              <Link
                                to="/profile-preferences"
                                onClick={(e) => {
                                  if (actionsDisabled) {
                                    e.preventDefault();
                                  }
                                }}
                                aria-disabled={actionsDisabled}
                                tabIndex={actionsDisabled ? -1 : 0}
                              >
                                Change Password
                                {/* /profile-preferences */}
                              </Link>
                              <i
                                className="fa fa-chevron-right"
                                aria-hidden="true"
                              ></i>
                            </li>
                            {/* <li className="list-group-item link">
                            <Link to="#">Legal Documents</Link>
                            <i
                              className="fa fa-chevron-right"
                              aria-hidden="true"
                            ></i>
                          </li> */}
                          </ul>
                        </div>
                      </div>
                      <div className="col-12 d-none">
                        <h3 className="sub-title theme-color black-color py-4">
                          CaliberCard Training Series
                        </h3>
                        {/* <iframe

                        src="https://www.youtube.com/embed/N2uFsI7w1wA"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen
                        className="video-iframe"
                      ></iframe> */}
                        <div className="video-frame-2">
                          <div className="container-fluid gx-0">
                            <div className="row">
                              <video
                                src="../video/video_preview_h264.mp4"
                                poster="../../images/Promo_Video_Image.png"
                                width={'100%'}
                                controls
                              ></video>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="container-fluid">
                  <div className="row d-none">
                    <div className="col-lg-6 g-0">
                      <div className="t-shirt p-3">
                        <img
                          src="../images/t-shirt2.png"
                          alt="t-shirt2"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="t-shirt-heading">
                        <h2 className="sub-title">
                          GET YOUR CALIBERCARD GEAR HERE!
                        </h2>
                        <Link
                          // to="https://teamlocker.squadlocker.com/#/lockers/calibercard"
                          className="theme-button login-button"
                        >
                          GEAR UP NOW
                        </Link>
                      </div>
                      <div className="shirt-line">
                        <img
                          src="../images/line.svg"
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* New Account Overview Section */}
              <div className="card-user-id-number">
                <div className=" container-fluid">
                  <div className="account-overview-section">
                    <div className="over-view-heading-line">
                      <h2 className="sub-title theme-color">
                        Account Overview
                      </h2>
                      <div className="border-line"></div>
                    </div>
                    <div className="row">
                      {/* Member Details Card */}
                      <div className="col-lg-6 mb-4">
                        <div className="overview-card">
                          <div className="overview-card-header">
                            <h3 className="card-label">MEMBER DETAILS</h3>
                          </div>
                          <div className="overview-card-body">
                            <h4 className="member-name">{memberName}</h4>
                            <p className="member-address">
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                              >
                                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                <circle cx="12" cy="10" r="3"></circle>
                              </svg>
                              {memberAddress}
                            </p>

                            <div className="member-info-list">
                              <div className="member-info-item">
                                <div className="info-icon">
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                  >
                                    <rect
                                      x="3"
                                      y="11"
                                      width="18"
                                      height="11"
                                      rx="2"
                                      ry="2"
                                    ></rect>
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                                  </svg>
                                </div>
                                <div className="info-content">
                                  <span className="info-label">Membership</span>
                                  <span className="info-value">
                                    {membershipName}
                                  </span>
                                </div>
                              </div>

                              <div className="member-info-item">
                                <div className="info-icon">
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                  >
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <polyline points="12 6 12 12 16 14"></polyline>
                                  </svg>
                                </div>
                                <div className="info-content">
                                  <span className="info-label">
                                    Membership Status
                                  </span>
                                  <span className="info-value status-active">
                                    {membershipStatus === 'active'
                                      ? 'Active'
                                      : membershipStatus || 'Active'}
                                  </span>
                                </div>
                              </div>

                              <div className="member-info-item">
                                <div className="info-icon">
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                  >
                                    <rect
                                      x="3"
                                      y="4"
                                      width="18"
                                      height="18"
                                      rx="2"
                                      ry="2"
                                    ></rect>
                                    <line x1="16" y1="2" x2="16" y2="6"></line>
                                    <line x1="8" y1="2" x2="8" y2="6"></line>
                                    <line x1="3" y1="10" x2="21" y2="10"></line>
                                  </svg>
                                </div>
                                <div className="info-content">
                                  <span className="info-label">
                                    Member Since
                                  </span>
                                  <span className="info-value">
                                    {memberSince}
                                  </span>
                                </div>
                              </div>

                              <div className="member-info-item">
                                <div className="info-icon">
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                  >
                                    <rect
                                      x="3"
                                      y="4"
                                      width="18"
                                      height="18"
                                      rx="2"
                                      ry="2"
                                    ></rect>
                                    <line x1="16" y1="2" x2="16" y2="6"></line>
                                    <line x1="8" y1="2" x2="8" y2="6"></line>
                                    <line x1="3" y1="10" x2="21" y2="10"></line>
                                  </svg>
                                </div>
                                <div className="info-content">
                                  <span className="info-label">Valid Upto</span>
                                  <span className="info-value">
                                    {validUpto}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Your Package Card */}
                      <div className="col-lg-6 mb-4">
                        <div className="overview-card">
                          <div className="overview-card-header">
                            <h3 className="card-label">YOUR PACKAGE</h3>
                          </div>
                          <div className="overview-card-body">
                            <div className="package-header-new">
                              <div className="package-icon">
                                <img
                                  src="../images/brand_emblem.svg"
                                  alt="membership"
                                  className="img-fluid"
                                />
                              </div>
                              <div className="package-info">
                                <span className="package-type">MEMBERSHIP</span>
                                <h4 className="package-name">
                                  {membershipName}
                                </h4>
                                {packagePriceLabel && (
                                  <span className="package-type">
                                    {packagePriceLabel}
                                  </span>
                                )}
                                <span className="package-status">
                                  <span className="status-dot"></span>
                                  {membershipStatus === 'active'
                                    ? 'ACTIVE'
                                    : (
                                        membershipStatus || 'ACTIVE'
                                      ).toUpperCase()}
                                </span>
                              </div>
                            </div>

                            <div className="package-benefits">
                              <h5 className="benefits-title">BENEFITS</h5>
                              <ul className="benefits-list">
                                {benefitsToRender.map((benefit, index) => (
                                  <li
                                    className="benefit-item"
                                    key={`${benefit}-${index}`}
                                  >
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="2.5"
                                    >
                                      <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    {benefit}
                                  </li>
                                ))}
                              </ul>
                            </div>

                            <button
                              className="cancel-membership-btn"
                              data-bs-toggle={
                                actionsDisabled ? undefined : 'modal'
                              }
                              data-bs-target={
                                actionsDisabled
                                  ? undefined
                                  : '#exampleModal_membership'
                              }
                              disabled={
                                actionsDisabled ||
                                subscription?.cancellation_status === 'pending'
                              }
                            >
                              CANCEL MEMBERSHIP
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="account-overview"></div>
              {/* <Accordion heading="LOOKING FOR INFORMATION?" /> */}
            </>
          )}
        </div>
      </AccountMainLayout>
      <div
        className="modal fade"
        id="exampleModal_membership"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body delete-text">
              <p>Are you sure you wish to cancel membership?</p>
            </div>
            <div className="modal-footer cancel-button">
              <button
                type="button"
                className="cancel ok"
                onClick={handleCancelMembership}
                disabled={actionsDisabled}
              >
                Yes
              </button>
              <button
                type="button"
                className="cancel cancel-address"
                data-bs-dismiss="modal"
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Overview;
